import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import * as Sentry from '@sentry/angular';

import { AppModule } from './app/app.module';
import { environment } from '@env/environment';

if (environment.production) {
  Sentry.init({
    dsn: 'https://31b4d75ae2ade5de62957e4cab1a6caf@o4506175294996480.ingest.sentry.io/4506201638764544',
    release: `publisher-panel@${environment.build}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // networkDetailAllowUrls: ['https://api.mylead.global', 'https://api.mylead.global/api/publisher_panel/user/me', 'https://api.mylead.biz'],
        // networkRequestHeaders: ['X-Custom-Header'],
        // networkResponseHeaders: ['X-Custom-Header']
        networkDetailAllowUrls: ['*', 'https://api.mylead.global/api/publisher_panel', 'https://api.mylead.global/api/publisher_panel/*'], // This will capture all URLs
        networkRequestHeaders: ['X-Custom-Header'],
        networkResponseHeaders: ['X-Custom-Header'],
        maskAllText: false,
        maskAllInputs: false
      })
    ],
    debug: false, // Enable debug mode for more verbose logging
    attachStacktrace: true, // Attach stacktraces to all messages
    normalizeDepth: 5, // Increase depth of object serialization
    maxBreadcrumbs: 50, // Increase number of breadcrumbs
    // Performance Monitoring
    tracesSampleRate: 0.1,
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', 'https://pub.mylead.global/', 'https://pub.mylead.biz/'],
    // Session Replay
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 0.5, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    sendDefaultPii: true,
    beforeSend(event) {
      // Dodajemy więcej kontekstu do każdego eventu
      event.extra = {
        ...event.extra,
        userAgent: navigator.userAgent,
        viewport: {
          width: window.innerWidth,
          height: window.innerHeight,
          pixelRatio: window.devicePixelRatio,
          orientation: window.screen.orientation?.type
        },
        memory: (performance as any).memory
          ? {
              jsHeapSizeLimit: (performance as any).memory.jsHeapSizeLimit,
              totalJSHeapSize: (performance as any).memory.totalJSHeapSize,
              usedJSHeapSize: (performance as any).memory.usedJSHeapSize
            }
          : null,
        connection: (navigator as any).connection
          ? {
              type: (navigator as any).connection.effectiveType,
              downlink: (navigator as any).connection.downlink
            }
          : null,
        performance: {
          timeOrigin: performance.timeOrigin,
          // Modern API replacement for timing
          navigationTiming: performance.getEntriesByType('navigation')[0]
        }
      };
      return event;
    }
  });

  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
